import { render, staticRenderFns } from "./BalancePurchase.html?vue&type=template&id=f84e2c2e&scoped=true&"
import script from "./BalancePurchase.js?vue&type=script&lang=js&"
export * from "./BalancePurchase.js?vue&type=script&lang=js&"
import style0 from "./BalancePurchase.scss?vue&type=style&index=0&id=f84e2c2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84e2c2e",
  null
  
)

export default component.exports